import { Checkbox } from 'antd';
import React from 'react';
import { ICurrency } from 'src/apis/common';

export interface IProps {
  currencies: ICurrency[];
  // The customer's current currency selection.
  currencyID: number;
  isActive: boolean;
}

const PlanHeader: React.FC<IProps> = (props) => {
  const selectedCurrency = props.currencies.find(currency => currency.id === props.currencyID);
  const currencyText = selectedCurrency
    ? `${selectedCurrency.code} - ${selectedCurrency.symbol} - ${selectedCurrency.name}`
    : 'Unknown!';

  return <section>
    <p>Currency: {currencyText}</p>
    <p><Checkbox checked={props.isActive} disabled={true}>Company is Active</Checkbox></p>
  </section>;
};

export default PlanHeader;
